import { Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage/HomePage';
import Hakkinda from './components/Hakkinda/Hakkinda';
import Program from './components/Program/Program';
import Alanlar from './components/Alanlar/Alanlar';
import DanismaKurulu from './components/DanismaKurulu/DanismaKurulu';
import DuzenlemeKurulu from './components/DuzenlemeKurulu/DuzenlemeKurulu';
import BildiriGonderimi from './components/BildiriGonderimi/BildiriGonderimi';
import DegerlendirmeSureci from './components/DegerlendirmeSureci/DegerlendirmeSureci';
import Olcutler from './components/Olcutler/Olcutler';
import YazimKurallari from './components/YazimKurallari/YazimKurallari';
import KabulEdilenler from './components/KabulEdilenler/KabulEdilenler';
import OnemliTarihler from './components/OnemliTarihler/OnemliTarihler';
import Kayit from './components/Kayit/Kayit';
import KatilimUcreti from './components/KatilimUcreti/KatilimUcreti';
import YayinOlanaklari from './components/YayinOlanaklari/YayinOlanaklari';
import Ulasim from './components/Ulasim/Ulasim';
import Konaklama from './components/Konaklama/Konaklama';
import Calistay from './components/Calistay/Calistay';


function App() {
  return (
    <>
      <Routes>
        {/* Ana Sayfa: Afişli ve özet bilgili kısım */}
        <Route path='/' element={<HomePage />} />

        {/* Alt Sayfalar: Afişsiz, sadece içerik odaklı sayfalar */}
        <Route path='/hakkinda' element={<Hakkinda />} />
        <Route path='/program' element={<Program />} />
        <Route path='/alanlar' element={<Alanlar />} />
        <Route path='/danisma' element={<DanismaKurulu />} />

        <Route path='/duzenleme' element={<DuzenlemeKurulu />} />

        <Route path='/bildiri-gonderimi' element={<BildiriGonderimi />} />
        <Route path='/degerlendirme-sureci' element={<DegerlendirmeSureci />} />
        <Route path='/olcutler' element={<Olcutler />} />
        <Route path='/yazim-kurallari' element={<YazimKurallari />} />
        <Route path='/kabul-edilenler' element={<KabulEdilenler />} />
        <Route path='/onemli-tarihler' element={<OnemliTarihler />} />

        <Route path='/kayit' element={<Kayit />} />
        <Route path='/katilim-ucreti' element={<KatilimUcreti />} />
        <Route path='/yayin' element={<YayinOlanaklari />} />
        <Route path='/ulasim' element={<Ulasim />} />
                <Route path='/konaklama' element={<Konaklama />} />
                                <Route path='/calistay' element={<Calistay />} />




      </Routes>
    </>
  );
}

export default App;